'use strict';
const _ = require('lodash');

module.exports = (input) => {
  if (_.isNil(input) || _.isEmpty(input)) {
    return input;
  }

  return _.toLower(input);
};
